import LandingStatuses from '../Constants/LandingStatuses';
import WeightNoteTypes from '../Constants/WeightNoteTypes';
import Landing from '../Models/LandingModels/Landing';
import WeightNote from '../Models/WeightNoteModels/WeightNote';

const pendingReweighterTypes = [
  WeightNoteTypes.FROM_REWEIGHTER,
  WeightNoteTypes.FROM_REWEIGHTER_OVERSEAS
];

export function isPendingFromReweighterWeightNote(weightNote: WeightNote | undefined): boolean {
  return Boolean(
    weightNote &&
    weightNote.isInternal &&
    !weightNote.isClosed &&
    weightNote.weightNoteType !== undefined &&
    pendingReweighterTypes.includes(weightNote.weightNoteType.id)
  );
}

export function hasPendingFromReweighterWeightNote(weightNotes: WeightNote[] | undefined): boolean {
  return weightNotes?.some(isPendingFromReweighterWeightNote) ?? false;
}

export function getEffectiveLandingStatusId(landing: Landing | undefined): number | undefined {
  const statusId = landing?.landingStatus?.id;
  if (
    statusId === LandingStatuses.CLOSED &&
    hasPendingFromReweighterWeightNote(landing?.weightNotes)
  ) {
    return LandingStatuses.NEEDS_REWEIGHTING;
  }
  return statusId;
}

export function withEffectiveLandingStatus(landing: Landing): Landing {
  const effectiveStatusId = getEffectiveLandingStatusId(landing);
  if (!landing.landingStatus || effectiveStatusId === undefined || effectiveStatusId === landing.landingStatus.id) {
    return landing;
  }

  return {
    ...landing,
    landingStatus: {
      ...landing.landingStatus,
      id: effectiveStatusId,
      name: effectiveStatusId === LandingStatuses.NEEDS_REWEIGHTING
        ? 'Vantar endurvigtun'
        : landing.landingStatus.name
    }
  };
}
